import React from "react";
import { Route, Routes } from "react-router-dom";
import CoachingVideoPage from "./CoachingVideoPage";

function NotFoundPage() {
  return (
    <main className="page">
      <section className="card">
        <img src="/logo_white_text.svg" alt="Sally logo" className="brand-logo" />
        <p className="session-complete">Page not found</p>
      </section>
    </main>
  );
}

function App() {
  return (
    <Routes>
      <Route path="/:token" element={<CoachingVideoPage />} />
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
}

export default App;
